import { useQuery } from '@tanstack/react-query';

import ApiCart from '@Api/Cart';

import type { GetRelatedProductsParams } from '@Api/Cart/getRelatedProducts';

function useRelatedProducts(params: GetRelatedProductsParams & { enabled: boolean }) {
  const { productId, enabled } = params;

  return useQuery({
    queryKey: ['cart-related-products', productId],
    queryFn: async () => {
      const { ok, data } = await ApiCart.getRelatedProducts(params);

      if (!ok) return [];

      return data.products[productId.toString()]?.related || [];
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: (previousData) => previousData,
  });
}

export default useRelatedProducts;
